import dayjs from "dayjs";
import arabic from "dayjs/locale/ar";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import relativeTime from "dayjs/plugin/relativeTime";

import { baseLanguage } from "@/Utils/locale-format";

dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

/**
 * Arabic month, weekday and relative-time names. The week start stays the
 * English default so week ranges do not move with the display language.
 */
dayjs.locale({ ...arabic, weekStart: 0 }, undefined, true);

const DAYJS_LOCALES = new Set(["en", "ar"]);

export function applyDayjsLanguage(language: string | undefined) {
  const base = baseLanguage(language);
  dayjs.locale(DAYJS_LOCALES.has(base) ? base : "en");
}

export default dayjs;
